export interface SharePermissions {
  basic_info: boolean;
  purchase_price: boolean;
  current_value: boolean;
  financing: boolean;
  rental_income: boolean;
  cashflow: boolean;
  renovation_costs: boolean;
  renovation_details: boolean;
  documents: boolean;
  photos: boolean;
  notes: boolean;
}

export const PERMISSION_LABELS: Record<keyof SharePermissions, string> = {
  basic_info: 'Basisdaten (Adresse, Größe)',
  purchase_price: 'Kaufpreis & Nebenkosten',
  current_value: 'Aktueller Marktwert',
  financing: 'Finanzierung',
  rental_income: 'Mieteinnahmen',
  cashflow: 'Cashflow-Berechnung',
  renovation_costs: 'Sanierungskosten',
  renovation_details: 'Sanierungsdetails',
  documents: 'Dokumente',
  photos: 'Fotos',
  notes: 'Notizen',
};

export const DEFAULT_PERMISSIONS: SharePermissions = {
  basic_info: true,
  purchase_price: false,
  current_value: false,
  financing: false,
  rental_income: false,
  cashflow: false,
  renovation_costs: false,
  renovation_details: false,
  documents: false,
  photos: true,
  notes: false,
};

export interface ShareProfile {
  id: string;
  user_id: string | null; // null = System-Template
  name: string;
  icon: string;
  permissions: SharePermissions;
  created_at: string;
}

export interface ShareLink {
  id: string;
  property_id: string;
  profile_id: string | null;
  custom_permissions: SharePermissions | null;
  token: string;
  name: string | null;
  expires_at: string | null;
  view_count: number;
  last_viewed_at: string | null;
  created_by: string;
  created_at: string;
  profile?: ShareProfile;
}

export type SharedPropertyImage = {
  id: string;
  storage_path: string;
  is_primary: boolean;
  category: string;
  url?: string; // Signed URL, optional generiert
};

export type SharedPropertyFinancing = {
  id: string;
  bank_name: string | null;
  loan_amount: number;
  interest_rate: number;
  repayment_rate: number;
  monthly_payment: number | null;
  start_date: string;
  fixed_interest_until: string | null;
};

export type SharedPropertyDocument = {
  id: string;
  name: string;
  category: string;
  storage_path: string;
  mime_type: string | null;
  file_size: number | null;
};

export type SharedPropertyData = {
  id: string;
  name: string;
  property_type: string;
  permissions: SharePermissions;
  link_name: string | null;
  created_at: string;
  // Optional, abhängig von Permissions:
  address_street?: string | null;
  address_zip?: string | null;
  address_city?: string | null;
  living_area_sqm?: number | null;
  land_area_sqm?: number | null;
  year_built?: number | null;
  num_units?: number | null;
  bundesland?: string | null;
  purchase_price?: number | null;
  cost_transfer_tax?: number | null;
  cost_notary?: number | null;
  cost_land_registry?: number | null;
  cost_broker?: number | null;
  cost_other?: number | null;
  additional_costs?: number | null;
  current_value?: number | null;
  rent_cold?: number | null;
  rent_warm?: number | null;
  renovation_cost_total?: number | null;
  financings?: SharedPropertyFinancing[];
  images?: SharedPropertyImage[];
  documents?: SharedPropertyDocument[];
};
